(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-ob-journal]').forEach(journal => {
      if (journal.dataset.obReady || !('IntersectionObserver' in window)) return;
      journal.dataset.obReady = 'true';
      const index = journal.querySelector('[data-ob-journal-index]');
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && index) index.textContent = entry.target.dataset.obChapter;
        });
      }, { rootMargin: '-20% 0px -40% 0px', threshold: 0 });
      journal.querySelectorAll('[data-ob-chapter]').forEach(scene => observer.observe(scene));
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(journal)) observer.disconnect();
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
